import UpdateUserAccountWrapper from './UpdateUserAccountWrapper';

export default UpdateUserAccountWrapper;
